export default "__VITE_ASSET__AsZq8A2A__"